import { SearchOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import searchTalentImg from "../../../../../assets/img/noResultsSearch.svg";
import PostingJob from "../../../../../assets/icons/PostingJob.svg";

import { openSearchDropdown } from "../../../../../redux/actions";
import styles from "./PlaceBidEmptyScreen.module.css";

const PlaceBidEmptyScreen = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const profile = useSelector(
    (state) => state.profileReducer.user
  );

  const hasPostedJob = profile?.isCurrentEmployerPostedJob;
console.info(hasPostedJob,'hasPostedJob')
  const handleSearchTalent = () => {
    dispatch(openSearchDropdown());
  };

  const handlePostJob = () => {
    history.push("/postjob");
  };

  const handleClick = hasPostedJob
    ? handleSearchTalent
    : handlePostJob;

  const imageSrc = hasPostedJob
    ? searchTalentImg
    : PostingJob;

  const title = hasPostedJob
    ? "Search the right talent"
    : "Start by Posting a Job";

  const description = hasPostedJob
    ? "You already have a job ready! Search for the best talent that matches your job requirements and place your bid to get started."
    : "To place a bid, first create a job listing so we can match you with the right talent. Once your job is ready, you can search for suitable candidates and submit your bid.";

  const buttonLabel = hasPostedJob
    ? "Search Talent"
    : "+ Post a Job";

  return (
    <div className={styles.page}>
      <div className={styles.screen}>
        <img
          src={imageSrc}
          alt="empty-state"
          className={styles.img}
        />

        <h2 className={styles.title}>{title}</h2>

        <p className={styles.desc}>{description}</p>

        <button
          className={styles.btn}
          onClick={handleClick}
        >
          {hasPostedJob && <SearchOutlined />}
          {buttonLabel}
        </button>
      </div>
    </div>
  );
};

export default PlaceBidEmptyScreen;